import heFlag from '@/modules/i18n/assets/flags/he-flag.svg?url';
import originalConfig from '@base-impl/modules/config/constants/defaultConfig';
import type { KnownConfig } from '@base-impl/modules/config/types/known-config';
import { set, unset } from 'lodash-es';
import type { PartialDeep } from 'type-fest';

const defaultConfig: PartialDeep<KnownConfig> = originalConfig;

// disable recipient setting and import export settings for branches that start with 'stage' or 'main'
set(defaultConfig, 'features.emailRecipientsSetting.enabled', true);
set(defaultConfig, 'features.importExportSettings.enabled', true);
set(defaultConfig, 'features.dashboardSettings.enabled', true);
set(defaultConfig, 'features.analytics.enabled', true);
set(defaultConfig, 'features.auth.enableTokenRefreshing', true);
set(defaultConfig, 'features.pushNotification.enabled', true);
export default defaultConfig;
